import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import Breadcrumbs from "../common/breadcrumbs";
import React from "react";
import ClientFilter from "./ClientFilter";
import { ClientRequest } from "http";
import ClientList from "./ClientList";
import Header from "../common/header";


const ClientDashboard = () => {
  const { clientStore: { pagination } } = useStore();

  return (
    <>
    
      {/* Dashboard Header and Filters */}
      <div className="listing-page max-md:pt-7 mt-5">
        {/* <Breadcrumbs title="Bookings" subtitle="Listings" /> */}
        {/* Search and Filters */}
        <ClientFilter pageSize={pagination?.pageSize} />
      </div>

      {/* Booking Grid View */}
      <section className="section booking-listing pt-0">
        <div className="container">
          <div className="row">
            {/* Booking Table */}
            <ClientList />
            {/* /Booking Table */}
          </div>
        </div>
      </section>
    </>
  );
};

export default observer(ClientDashboard);
